import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/less/global.less'
import {instance} from '@/utils/request.js';
import '@/icons'

import * as filters from './assets/js/filters'

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

import './registerServiceWorker'

import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
Vue.use(Antd);
Vue.prototype.$http = instance;

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
